import { render } from "./modal-add.vue?vue&type=template&id=dfd965fe&scoped=true"
import script from "./modal-add.vue?vue&type=script&lang=js"
export * from "./modal-add.vue?vue&type=script&lang=js"

import "./modal-add.vue?vue&type=style&index=0&id=dfd965fe&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfd965fe"],['__file',"src/components/admin-dashboard/modals/modal-add.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dfd965fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dfd965fe', __exports__)) {
    api.reload('dfd965fe', __exports__)
  }
  
  module.hot.accept("./modal-add.vue?vue&type=template&id=dfd965fe&scoped=true", () => {
    api.rerender('dfd965fe', render)
  })

}


export default __exports__